import React, { useState } from 'react';
import { Menu, Phone, Trash2, X } from 'lucide-react';
import { Button } from '../ui/Button';
const NAV_LINKS = [{
  label: 'Sizes & Pricing',
  href: '#sizes'
}, {
  label: 'Service Areas',
  href: '#service-areas'
}, {
  label: 'Accepted Materials',
  href: '#materials'
}, {
  label: 'FAQ',
  href: '#faq'
}];
interface HeaderProps {
  onReserve: () => void;
}
export function Header({
  onReserve
}: HeaderProps) {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-border bg-background/90 backdrop-blur" data-id="element-218">
      <div className="container flex h-16 items-center justify-between" data-id="element-219">
        <a href="#top" className="flex items-center gap-2" data-id="element-220">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground" data-id="element-221">
            <Trash2 className="h-5 w-5" data-id="element-222" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-223">
            <span className="text-base font-semibold tracking-tight" data-id="element-224">
              Greeneway
            </span>
            <span className="text-xs text-muted-foreground" data-id="element-225">
              Dumpster Rental
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary" data-id="element-226">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground" data-id="element-227">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 md:flex" data-id="element-228">
          <a href="tel:+15551234567" className="flex items-center gap-2 text-sm font-medium text-foreground" data-id="element-229">
            <Phone className="h-4 w-4 text-primary" data-id="element-230" />
            (555) 123-4567
          </a>
          <Button onClick={onReserve} data-id="element-231">Reserve a dumpster</Button>
        </div>

        <button type="button" className="inline-flex h-9 w-9 items-center justify-center rounded-md text-foreground md:hidden" onClick={() => setOpen(v => !v)} aria-label="Toggle menu" aria-expanded={open} data-id="element-232">
          {open ? <X className="h-5 w-5" data-id="element-233" /> : <Menu className="h-5 w-5" data-id="element-234" />}
        </button>
      </div>

      {open && <div className="border-t border-border bg-background md:hidden" data-id="element-235">
          <nav className="container flex flex-col py-4" aria-label="Mobile" data-id="element-236">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="py-2 text-sm text-muted-foreground hover:text-foreground" data-id="element-237">
                {link.label}
              </a>)}
            <a href="tel:+15551234567" className="flex items-center gap-2 py-2 text-sm font-medium" data-id="element-238">
              <Phone className="h-4 w-4 text-primary" data-id="element-239" />
              (555) 123-4567
            </a>
            <Button className="mt-3" onClick={() => {
          setOpen(false);
          onReserve();
        }} data-id="element-240">
              Reserve a dumpster
            </Button>
          </nav>
        </div>}
    </header>;
}